module.exports = __webpack_public_path__ + "static/media/aeromall_white.246e7ea6.svg";